var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox",class:{ checked: _vm.checked },on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"custom-checkbox__icon"}),_c('div',{staticClass:"custom-checkbox__label"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }